import { GraduationCap, LineChart } from 'lucide-react';
import { useBetMode, setBetMode } from '../lib/betMode';

const OPTS = [['amateur', 'Amateur', GraduationCap, 'Plain English — no betting terms'], ['pro', 'Pro', LineChart, 'Bettor shorthand: o199.5, ML, proj, L5']];

// Flips every pick in the app between plain-English and pro wording.
export default function BetModeSwitch({ compact = false }) {
  const mode = useBetMode();
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="bet-mode-switch">
      <div className="inline-flex rounded-full border border-zinc-700 bg-zinc-900 p-0.5">
        {OPTS.map(([k, l, Icon]) => (
          <button key={k} type="button" onClick={() => setBetMode(k)} data-testid={`bet-mode-${k}`}
            className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold transition-colors ${mode === k ? 'bg-amber-500 text-black' : 'text-zinc-400 hover:text-white'}`}>
            <Icon className="w-3.5 h-3.5" />{l}
          </button>
        ))}
      </div>
      {!compact && <span className="text-[11px] text-zinc-500" data-testid="bet-mode-hint">{OPTS.find((o) => o[0] === mode)[3]}</span>}
    </div>
  );
}
